import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'

export const Wrapper = styled.div`
  width: 100%;
  margin: ${em(40)} auto 0;

  ${p => p.theme.mq.upMd} {
    position: absolute;
    left: 40%;
    top: 30%;
    transform: translate(-50%, 10%);
    margin-top: 0;
  }

  ${p => p.theme.mq.upLg} {
    width: 140%;
    left: 0;
    top: auto;
    bottom: 0;
    transform: translate(-15%, 14%);
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  ${p => p.theme.mq.upMd} {
    width: 165%;
    max-width: ${em(600)};
  }
  ${p => p.theme.mq.upLg} {
    width: 100%;
    max-width: none;
  }
`
